import { cn } from "@/lib/utils";
import BrandMark from "@/components/yts/BrandMark";

/**
 * Shared wordmark placement across header, footer and compact chrome.
 * The lockup sizes itself from type, so a placement only adjusts colour here;
 * any width class a caller passes just frames it.
 */
export default function BrandLogo({ variant = "header", className = "", forceDark = false }) {
  return <BrandMark variant={variant} forceDark={forceDark} className={cn("align-middle", className)} />;
}